<template>
    <card>
        <card-header>
            <card-title>
                <translate>abgelaufene und abgelehnte Angebote</translate>
            </card-title>
        </card-header>
        <card-content>
            <table class="table table--stripped table--td-top">
                <thead>
                <tr>
                    <th>
                        <translate>PF-Nr</translate>
                    </th>
                    <th>
                        <translate>Projekttitel</translate>
                    </th>
                    <th class="text-center">
                        <translate>Zeichnung</translate>
                    </th>
                    <th class="text-right">
                        <translate>Stück</translate>
                    </th>
                    <th class="text-right">
                        <translate>Stückpreis</translate>
                    </th>
                    <th class="text-right">
                        <translate>Nettopreis</translate>
                    </th>
                    <th class="text-right">
                        <translate>Lieferzeit</translate>
                    </th>
                    <th class="text-right">
                        <translate>gültig bis</translate>
                    </th>
                    <th class="text-right">
                        <translate>Angebote<span>alternative</span></translate>
                    </th>
                    <th class="text-right">
                        <translate>abgelehnt<span>am</span></translate>
                    </th>
                    <th>
                        <translate>abgelehnt<span>Grund</span></translate>
                    </th>
                    <th>
                        <translate>abgelehnt<span>Kommentar</span></translate>
                    </th>
                    <th>
                        <translate>Status</translate>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="offer in inactiveOffersTable" :key="offer.index">
                    <td>
                        <Link :href="this.$$route('component', {'askForQuote':offer.id})">{{ offer.pfnumber }}</Link>
                    </td>
                    <td>{{ offer.project_name }}</td>
                    <td class="text-center">
                        <file-download :sketch-file="offer.client_sketch_file" v-if="offer.client_sketch_file"/>
                        <file-download :cad-file="offer.client_cad_file" v-if="offer.client_cad_file"/>
                    </td>
                    <td class="text-right" v-html="offer.lot_qty"></td>
                    <td class="text-right" v-html="offer.price_per_unit"></td>
                    <td class="text-right" v-html="offer.net_price"></td>
                    <td class="text-right" v-html="offer.lot_delivery_days"></td>
                    <td class="text-right">{{ offer.offer_valid_date }}</td>
                    <td class="text-right">
                        {{ offer.bid_round_member_offers_count_string }}
                    </td>
                    <td class="text-right">
                        {{ offer.rejected_at_string }}
                    </td>
                    <td>
                        <translate>{{ offer.reject_reason }}</translate>
                    </td>
                    <td>
                        {{ offer.reject_comment }}
                    </td>
                    <td>
                        <translate>{{ offer.reject_status }}</translate>
                    </td>
                </tr>
                <tr v-if="noOffers">
                    <td colspan="13" class="text-center">
                        <strong>
                            <translate>keine Einträge vorhanden</translate>
                        </strong>
                    </td>
                </tr>
                </tbody>
            </table>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import FileDownload from '@partfactory/Shared/Elements/FileDownload';

export default {
    name: 'DashboardInactiveOffers',
    components: {FileDownload, CardHeader, CardTitle, CardContent, Card},
    props: {
        inactiveOffers: Object,
    },
    computed: {
        noOffers() {
            return this.inactiveOffers.length === 0;
        },
        inactiveOffersTable() {
            let offer = Array;
            return Object.keys(this.inactiveOffers).map(key => {
                offer[key] = this.inactiveOffers[key];

                let lotQty = [], pricePerUnit = [], netPrice = [], lotDeliveryDays = [], offerValidDate = '',
                    offerRejectedAt = '', rejectReason = '', rejectComment = '';

                offer[key].client_offers.map((offer) => {
                    lotQty.push(offer.amount);
                    pricePerUnit.push(offer.net_price / offer.amount);
                    netPrice.push(offer.net_price);
                    lotDeliveryDays.push(offer.delivery_days_client);
                    offerValidDate = this.$date(offer.offer_valid_date);
                    offerRejectedAt = offer.rejected_at ? this.$date(offer.rejected_at) : null;
                    rejectReason =offer.reject_reason;
                    rejectComment =offer.reject_comment;
                });

                offer[key].lot_qty = lotQty.filter(lot => lot !== null).join('<br>');

                offer[key].price_per_unit = pricePerUnit.map(lot => {
                    return lot ? this.$currency(lot) : '';
                }).join('<br>');

                offer[key].net_price = netPrice.map(lot => {
                    return lot ? this.$currency(lot) : '';
                }).join('<br>');

                offer[key].lot_delivery_days = lotDeliveryDays.map((lot) => {
                    return lot + ' Tage';
                }).join(' <br>');

                offer[key].bid_round_member_offers_count_string = offer[key].bid_round_member_offers_count - 1;

                offer[key].offer_valid_date = offerValidDate;

                offer[key].rejected_at_string = offerRejectedAt;

                offer[key].reject_reason = this.$readableRejectReason(rejectReason);

                offer[key].reject_comment = rejectComment;

                offer[key].reject_status = rejectComment ? 'Angebot abgelehnt' : 'Angebot abgelaufen';

                return offer[key];
            });
        },
    },
};
</script>
